import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api-client";

export const getAppointments = async () => {
    const res = await api.get("/Clinician/Appointments");

    return res.data;
};

export const useAppointments = (options) => {
    return useQuery({
        queryKey: ["appointments"],
        queryFn: getAppointments,
        retry: 3,
        staleTime: 1000 * 60,
        enabled: options?.enabled ?? true,
    });
};
